function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { Loader } from '@nordlayer/rivendell-ui';
import { OrderForm, OrdersHistory } from 'modules/Orders';
import { OrganizationMonetizationSettings } from 'modules/OrganizationMonetizationSettings';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { Features } from 'types/features/enums';
import { PermissionsEnum } from 'types/permissions/enums';
import { ORGANIZATIONS_ACTIVITY_PATH, ORGANIZATIONS_GATEWAYS_PATH, ORGANIZATIONS_GATEWAY_PATH, ORGANIZATIONS_LIST_PATH, ORGANIZATIONS_MEMBERS_PATH, ORGANIZATIONS_NOTES_PATH, ORGANIZATIONS_ORDERS_PATH, ORGANIZATIONS_ORDER_CREATE_PATH, ORGANIZATIONS_SERVERS_PATH, ORGANIZATIONS_SERVER_PATH, ORGANIZATIONS_SETTINGS_PATH, ORGANIZATIONS_TEAMS_PATH, ORGANIZATIONS_TEAM_PATH, ORGANIZATIONS_VIEW_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var List = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationList');
});
var OrganizationView = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationView');
});
var OrganizationOrders = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationOrders');
});
var OrganizationMembers = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationMembers');
});
var OrganizationTeams = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationTeams');
});
var OrganizationTeam = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationTeam');
});
var OrganizationGateways = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationGateways');
});
var OrganizationGateway = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationGateway');
});
var OrganizationServers = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationServers');
});
var OrganizationServer = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationServer');
});
var OrganizationActivities = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationActivities');
});
var OrganizationNotes = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/OrganizationNotes');
});
export var OrganizationsRouting = function OrganizationsRouting(_ref) {
    var areFeaturesLoaded = _ref.areFeaturesLoaded, isOrdersRedesignEnabled = _ref.isOrdersRedesignEnabled;
    // Same path, FF picks the component: redesigned Orders page vs. the legacy one.
    var getOrdersPage = function getOrdersPage() {
        if (!areFeaturesLoaded) {
            return /*#__PURE__*/ _jsx(Loader, {
                centered: true
            });
        }
        return isOrdersRedesignEnabled ? /*#__PURE__*/ _jsx(OrdersHistory, {}) : /*#__PURE__*/ _jsx(OrganizationOrders, {});
    };
    return RouteGenerator(_objectSpread(_objectSpread({
        list: {
            path: ORGANIZATIONS_LIST_PATH,
            component: List,
            exact: true
        },
        orders: {
            path: ORGANIZATIONS_ORDERS_PATH,
            component: function component() {
                return getOrdersPage();
            },
            exact: true
        }
    }, areFeaturesLoaded && isOrdersRedesignEnabled && {
        orderCreate: {
            path: ORGANIZATIONS_ORDER_CREATE_PATH,
            component: OrderForm,
            exact: true,
            permission: PermissionsEnum.CreateOrder
        }
    }), {}, {
        view: {
            path: ORGANIZATIONS_VIEW_PATH,
            component: OrganizationView,
            exact: true
        },
        gateways: {
            path: ORGANIZATIONS_GATEWAYS_PATH,
            component: OrganizationGateways,
            exact: true
        },
        gateway: {
            path: ORGANIZATIONS_GATEWAY_PATH,
            component: OrganizationGateway,
            exact: true
        },
        teams: {
            path: ORGANIZATIONS_TEAMS_PATH,
            component: OrganizationTeams,
            exact: true
        },
        team: {
            path: ORGANIZATIONS_TEAM_PATH,
            component: OrganizationTeam,
            exact: true
        },
        members: {
            path: ORGANIZATIONS_MEMBERS_PATH,
            component: OrganizationMembers,
            exact: true
        },
        servers: {
            path: ORGANIZATIONS_SERVERS_PATH,
            component: OrganizationServers,
            exact: true
        },
        server: {
            path: ORGANIZATIONS_SERVER_PATH,
            component: OrganizationServer,
            exact: true
        },
        activity: {
            path: ORGANIZATIONS_ACTIVITY_PATH,
            component: OrganizationActivities,
            exact: true
        },
        notes: {
            path: ORGANIZATIONS_NOTES_PATH,
            component: OrganizationNotes,
            exact: true
        },
        settings: {
            path: ORGANIZATIONS_SETTINGS_PATH,
            component: OrganizationMonetizationSettings,
            exact: true,
            permission: PermissionsEnum.PackageChange,
            feature: Features.MonetizationSettingsPage
        }
    }));
};
